export default {
    apiKey: process.env.MIX_FIREBASE_CLIENT_API_KEY,
    authDomain: process.env.MIX_FIREBASE_CLIENT_AUTH_DOMAIN,
    projectId: process.env.MIX_FIREBASE_CLIENT_PROJECT_ID,
    storageBucket: process.env.MIX_FIREBASE_CLIENT_STORAGE_BUKCET,
    messagingSenderId: process.env.MIX_FIREBASE_CLIENT_MESSAGING_SENDER_ID,
    appId: process.env.MIX_FIREBASE_CLIENT_APP_ID,
}

let vapidKey = process.env.MIX_FIREBASE_CLIENT_VAPID_KEY

export { vapidKey }
